var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-row workflow-description flex-align-center"},[(_vm.showProjectChip)?_c('ProjectChip',{attrs:{"projectId":_vm.flowData.project}}):_vm._e(),_c('div',{staticClass:"one-row"},[_vm._v(_vm._s(_vm.flowType)+_vm._s(_vm.flowLocation)+", "+_vm._s(_vm.flowCreator))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }